"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgPencil = function SvgPencil(_ref) {
  var fill = _ref.fill,
      theme = _ref.theme,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "theme", "title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.29 30.971H5.85a1.537 1.537 0 110-3.074H24.29a1.537 1.537 0 110 3.074zM20.666 9.168l-2.899-2.28 1.9-2.416 2.9 2.281-1.901 2.415zm4.858-3.999L20.51 1.225a1.728 1.728 0 00-2.427.29L6.466 16.278c-.158.2-.27.432-.327.68l-1.684 7.299c-.164.712.123 1.36.616 1.747.492.387 1.19.515 1.843.187l6.697-3.354c.228-.113.427-.276.584-.476L25.812 7.597a1.728 1.728 0 00-.289-2.428z",
      fill: "#27255F"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "Pencil_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 4,
      y: 0,
      width: 23,
      height: 31,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.29 30.971H5.85a1.537 1.537 0 110-3.074H24.29a1.537 1.537 0 110 3.074zM20.666 9.168l-2.899-2.28 1.9-2.416 2.9 2.281-1.901 2.415zm4.858-3.999L20.51 1.225a1.728 1.728 0 00-2.427.29L6.466 16.278c-.158.2-.27.432-.327.68l-1.684 7.299c-.164.712.123 1.36.616 1.747.492.387 1.19.515 1.843.187l6.697-3.354c.228-.113.427-.276.584-.476L25.812 7.597a1.728 1.728 0 00-.289-2.428z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#Pencil_svg__a)",
      children: (0, _jsxRuntime.jsx)("path", {
        fill: fill || theme.colors.primary.main,
        d: "M-47.158-47.158H78.944V79.158H-47.158z"
      })
    })]
  }));
};

var _default = SvgPencil;
exports["default"] = _default;